import { MessagingProxy } from '../../services/cap-proxy'
import { autoinject } from 'aurelia-framework';
import { RedirectToRoute, RoutableComponentCanActivate } from 'aurelia-router';
import { timeout, defaultTimeout } from '../../services/timeout';
import { Remote, MultipleResponse, XrmContext } from '../../services/shared-crm-proxy-types';
import { OrganizationProperties, SatelliteViewProperties } from '../../services/organization-info';
import { types } from "../../services/query-proxy";


@autoinject
export class Home implements RoutableComponentCanActivate {

    constructor(private proxy: MessagingProxy<Remote>) {

    }

    async canActivate(): Promise<RedirectToRoute> {

        console.log('Query param: %s', window.location.search);
        const params = this.deserialize(window.location.search.substring(1));

        // Check if the full license dashboard is requested or only the satellite view (without connection to CRM)
        if (params["satellite"] === "true") {
            console.log("Minimal license overview requested, redirecting to satellite view.");

            // Read environmentID and contractID from query parameters
            const environmentId = params["environmentid"] || null;
            const contractId = params["contractid"] || null;
            const chartOnly = params["chartonly"] === "true";
            const hideChartBtn = params["hidechartbtn"] === "true";

            if (environmentId === null) {
                return new RedirectToRoute("error", { errorMessage: "Environment ID is missing." });
            }

            const satelliteViewProperties: SatelliteViewProperties = {
                organizationId: environmentId,
                contractId: contractId,
                chartOnly: chartOnly,
                hideChartBtn: hideChartBtn
            };

            if (chartOnly) {

                // When showing report directly, contract ID is required too
                if (contractId === null) {
                    return new RedirectToRoute("error", { errorMessage: "Contract ID is missing." });
                }
            }

            return new RedirectToRoute("licensing-overview-satellite", satelliteViewProperties);
        }

        // Full License dashbard requested, this must be loaded in context of CRM

        // When not loaded in CRM frame, display error
        if (top === window) {
            return new RedirectToRoute("error", { errorMessage: "Please load the custom admin page from CRM via Settings > License Administration!" });
        }
        try {
            // When loaded in CRM from frame, call helloCRM with proxy to test CRM connection 
            const proxyVersion: string = await timeout(defaultTimeout,
                <Promise<string>>this.proxy.invoke("helloCRM", "v2")
            );

            console.log('Connected to CRM. Version: %s', proxyVersion);

            const orgInfo: OrganizationProperties = await this.getOrganizationInfoFromCrm();

            if (params["fmnl"]) {
                orgInfo.usefmnl = true;
            }

            return new RedirectToRoute("licensing-overview", orgInfo);
        } catch (e) {
            console.error("Could not connect to CRM.", e);
            return new RedirectToRoute("error", { errorMessage: "Could not connect to CRM. Please make sure you have loaded this page from within the context of CRM and try again." });
        }
    }

    private deserialize(searchPath: string) {

        return String(searchPath)
            .split("&")
            .reduce((result, param) => {
                let [key, value] = param.replace('+', ' ').split('=', 2);
    
                result[key.toLowerCase()] = decodeURIComponent(value);
    
                return result;
            }, {});
    }

    private async getOrganizationInfoFromCrm(): Promise<OrganizationProperties> {

        const retrieveOrganizations: types.FilterRequest = {
            apiVersion: "v8.2",
            entitySetName: "organizations",
            type: types.RetrieveRequestType.ByFilter
        };

        let organizationId: string;

        const orgIdPromise = timeout(defaultTimeout,
            this.proxy.invoke("executeQuery", retrieveOrganizations)
        )
            .then((orgs: MultipleResponse) => orgs.value[0])
            .then(org => {
                console.log("Organization: ", org);
                return org.organizationid;
            });

        const uniqueNamePromise = timeout(defaultTimeout,
            this.proxy.invoke("getXrmContext")
        )
            .then((context: XrmContext) => {
                console.log("XrmContext: ", context);
                return context.orgUniqueName;
            });

        return Promise.all([orgIdPromise, uniqueNamePromise])
            .then((values: string[]) => {
                let [organizationId, organizationName] = values;
                return { organizationId, organizationName, usefmnl: false };
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/components/home/home.ts